




































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IDocument} from '../../contract/document.contract';
import {IOci} from '../../contract/oci.contract';
import displayStore from '@/store/modules/display/displayStore';
import {translatedPropertyService} from '@/shared/i18n/translated-property.service';
import {Constants} from '@/constants';
import {extractTranslation, extractTranslationAndReturnFirst} from '../../services/util/translation-extractor';
import {ObjectType} from '@/model/object-type';
import {LANGUAGE_TRANSLATIONS} from '@/model/languages';


@Component({})
export default class SearchResultCard extends Vue {
  @Prop()
  public document!: IDocument;

  @Prop()
  public oci!: IOci;

  public get isMobile(): boolean {
    return displayStore.state.isMobile;
  }

  public get icon(): string {
    const objectType = extractTranslation<string>(this.document.objectType);

    switch(objectType) {
      case 'Certificaat':
      case 'Certificat':
      case 'Certificate':
        return 'file-certificate';
      case 'Technische goedkeuring':
      case 'Agrément technique':
      case 'Technical approval':
        return 'file-technical-sheet';
      case 'Technische fiche':
      case 'Fiche technique':
      case 'Technical sheet':
        return 'file-technical-sheet';
      case 'Productcataloog':
      case 'Catalogue de produits':
      case 'Product catalogue':
        return 'file-catalog';
      case 'Productlijst':
      case 'Liste de produits':
      case 'Product list':
        return 'file-list';
      case 'Uitvoerderslijst':
      case 'Liste d\'exécutants':
      case 'List of executants':
        return 'file-list';
      case 'Reglement':
      case 'Règlement':
      case 'Rules':
        return 'file-product-description';
      case 'Technische specificatie':
      case 'Spécification technique':
      case 'Technical specification':
        return 'file-technical-sheet';
      case 'Gebruiksgeschiktheidsattest':
      case 'Attestation d\'aptitude à l\'emploi':
      case 'Attestation of fitness for use':
        return 'file-certificate';
      default:
        return 'file-pdf';
    }
  }

   public get language(): string {
    const languages = extractTranslation(this.document.language);
    return languages?.map(lang => LANGUAGE_TRANSLATIONS.find(language => language.translations.includes(lang))?.language || '')?.join('\n') || '';
  }

  public get logoOci(): string  {
    return this.oci?.logo || '';
  }

  public get logo(): string {
    return extractTranslation<string>(this.document.logoUri) || '';
  }

  public get hasBrandName(): boolean {
    return Boolean(extractTranslation(this.document.mark)?.join(', ') || '');
  }

  public get brandName(): string | undefined {
    return extractTranslation(this.document.mark)?.join(', ');
  }

  public get pdfLink(): string {
    const url = encodeURIComponent(translatedPropertyService.translateProperty(this.document.url));
    return `${Constants.ApiBaseUrl}documents?url=${url}`;
  }

  public get privateLink(): string {
    return translatedPropertyService.translateProperty(this.document.url) || '';
  }

  public get identifier(): string {
    return this.document.identifier || '/';
  }

  public get certificateOwner(): string | undefined {
    return extractTranslation(this.document.certificateOwner)?.map(_ => _.name).join(', ');
  }

  public get snelcode(): string | undefined {
    return extractTranslation(this.document.snelcode)?.join(', ');
  }

  public get commercialName(): string | undefined {
    return extractTranslation(this.document.commercialName)?.join(', ');
  }

  public get variousProperties(): string {
    const typeSystem = extractTranslationAndReturnFirst(this.document.typeSystem) || '';
    const certifiedProductType = extractTranslationAndReturnFirst(this.document.certifiedProductType) || '';
    const processes = extractTranslationAndReturnFirst(this.document.processes) || '';
    const services = extractTranslationAndReturnFirst(this.document.services) || '';

    const propertyArray = [typeSystem, certifiedProductType, processes, services].filter(e => {
      return e !== '';
    });

    return propertyArray.join(' | ');
  }

  public showSearchResultDetailsTable() {
    this.$emit('showDetailsClicked', this.identifier);
  }
}
